import axios, { AxiosPromise } from 'axios';
import { api } from '../config/Master';
import { EVIDENTLY_FEATURES, OffersMetrics } from '../constants/evidently';

export interface TrackEvidentlyMetricsParams<KeysType> {
  hashId?: string;
  experimentName?: string;
  featureName?: string;
  key?: OffersMetrics | KeysType;
  value?: number;
  shouldAddUpValue?: boolean;
}

export interface SendEvidentlyMetricsParams {
  userId: string;
  details: { [key: string]: string | number };
}

/**
 Gets evidently variation response
 **/
const fetchEvalFeature = (featureName: any): AxiosPromise => {
  const formData = {
    featureName: featureName,
  };

  return axios({
    method: 'POST',
    url: `${api}/evidently/evaluate-feature`,
    data: formData,
  });
};

/**
 Gets evidently variation response
 **/
const batchEvaluateFeature = ({
  userId,
  features,
}: {
  userId?: string;
  features: {
    feature: EVIDENTLY_FEATURES;
    entityId?: string;
    evaluationContext?: Record<string, unknown>;
  }[];
}): AxiosPromise => {
  return axios({
    method: 'POST',
    url: `${api}/evidently/batch-evaluate-feature`,
    data: { userId, features },
  });
};

/**
 Send metrics on evidently variants
 **/
const sendEvidentlyMetrics = ({ userId, details }: SendEvidentlyMetricsParams): AxiosPromise => {
  const formData = {
    details,
    userDetails: {
      userId,
      sessionId: userId,
    },
  };

  return axios({
    method: 'POST',
    url: `${api}/evidently/send-metric`,
    data: formData,
  });
};

/**
 *
 * @param experiment string
 * @returns AxiosPromise
 */
const getEvidentlyExperiment = (experiment: string): AxiosPromise => {
  return axios({
    method: 'GET',
    url: `${api}/evidently/experiment/${experiment}/get`,
  });
};

const doWebTimestampCheck = (): AxiosPromise => {
  return axios({
    method: 'GET',
    url: `${api}/webTimestampCheck`,
  });
};

/**
 Track metrics on evidently variants
 **/
const trackEvidentlyMetrics = <KeysType>(formData: TrackEvidentlyMetricsParams<KeysType>): AxiosPromise => {
  return axios({
    method: 'POST',
    url: `${api}/evidently/track-metric`,
    data: { ...formData },
  });
};

/**
 Track multiple metrics on evidently variants
 **/
const trackEvidentlyMultipleMetrics = <KeysType>(formData: TrackEvidentlyMetricsParams<KeysType>[]): AxiosPromise => {
  return axios({
    method: 'POST',
    url: `${api}/evidently/track-multiple-metric`,
    data: {
      metrics: [...formData],
    },
  });
};

export {
  fetchEvalFeature,
  doWebTimestampCheck,
  sendEvidentlyMetrics,
  getEvidentlyExperiment,
  batchEvaluateFeature,
  trackEvidentlyMetrics,
  trackEvidentlyMultipleMetrics,
};
